/* if you modify this file, please remove this line then fix eslint errors. */ /* eslint-disable */
import { Component } from 'react';
import omit from 'lodash/omit';
import Autocomplete from '../Autocomplete';
import AutocompleteSelections from '../AutocompleteSelections';

function uniqArray(arrayToUnique) {
  return arrayToUnique.filter((item, index) => arrayToUnique.indexOf(item) === index);
}

export class AutocompleteMultiple extends Component {
  static defaultProps = {
    defaultValues: [],
    sortable: false,
    onChange() {},
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedItems: this.props.defaultValues,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const currentIds = this.state.selectedItems.map((item) => item.id);
    const nextIds = nextState.selectedItems.map((item) => item.id);

    return currentIds.length !== nextIds.length || nextIds.toString() !== currentIds.toString();
  }

  componentDidUpdate() {
    this.props.onChange(this.state.selectedItems);
  }

  addItem = (item) => {
    this.setState((prevState) => {
      const selectedItems = [...prevState.selectedItems, item];

      return {
        selectedItems: uniqArray(selectedItems),
      };
    });
  };

  removeItem = (itemToRemove) => {
    this.setState((prevState) => ({
      selectedItems: prevState.selectedItems.filter((item) => item.id !== itemToRemove.id),
    }));
  };

  setItems = (newItems) => {
    this.setState(() => ({ selectedItems: newItems }));
  };

  render() {
    const omittedProps = ['defaultValue', 'defaultValues', 'onSelectValue', 'onChange', 'sortable'];

    return (
      <span className="autocompleteMultiple">
        <Autocomplete
          {...omit(this.props, omittedProps)}
          excludedIds={this.state.selectedItems.map((item) => item.id)}
          onSelectValue={this.addItem}
          resetOnSelect
        />
        <AutocompleteSelections
          items={this.state.selectedItems}
          onRemoveItem={this.removeItem}
          sortable={this.props.sortable}
          onSort={this.setItems}
        />
      </span>
    );
  }
}

export default AutocompleteMultiple;
